/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
require.context("../images", true, /\.(png|jpg|jpeg|svg|ico)$/);
import "core-js/stable";
import "regenerator-runtime/runtime";
// CSS
import "../src/application";
// Javascript
// + Library
require("@rails/ujs").start();
require('jquery-inview');
//= require toastr

import 'bootstrap/js/src';

// For interview
import moment from 'moment'
import 'fullcalendar';
import 'tablednd';

// For DJ-3026
require("webpack-jquery-ui/css");
require("webpack-jquery-ui");
require("jquery");
window.$ = $;
require("bootstrap-timepicker");
//= require toastr

// require("./channels"); // current, it is unnecessary
import * as Routes from "./js-routes.js.erb";
import "./env.js.erb";

window.Routes = Routes;

// + For Website
import Shared from "./shared";
import Cookie from "./cookie";
import JobTag from "./job_tag";
import ResumeSearches from "./pages/resume_searches";
import NewResumeSearches from "./pages/new_resume_searches";
import CompanyApplicant from "./company_applicant";
import CompanyScout from "./company_scout";
import ResumeUpdateRequest from './resume_update_request'
import TranslationSimple from "./translation_simple";
import TranslationJob from "./translation_job";
import TranslationProfileIntro from "./translation_profile_intro";
import MemberJobFolders from "./pages/member_job_folders";
import CompanyNotes from './pages/company_notes';
import CandidateNotes from './pages/candidate_notes';
import Joblist from './pages/joblist';
import JobForm from './pages/job_form';
import MailTemplate from "./pages/mail_template";
import MailTemplateSample from "./pages/mail_template_sample";
import CompanyWebEdit from "./pages/company_web_edit";
import CompanyUser from "./pages/company_user";
import DependentLocation from "./components/dependent_location";
import Scout from "./pages/scout";
import RecommendTileContainer from "./recommend_tile_container";
import MemberRecommendationSearch from "./pages/member_recommendation_search";
import LogoutDialog from "./components/logout_dialog";
import JobSearch from "./pages/job_search";
import Schedule from "./schedule";
import JQuery from "jquery";
import CtAnnouncement from './pages/ct_announcement';
import Message from "./pages/message";
import Interview from "./pages/interview";
import FlashMessage from './flash_message';
import ResumeSearchResult from './resume_search_result';
import AutoScoutMessageTemplate from './pages/automatic_scouts/auto_scout_message_template';
import AutomaticScoutCondition from './pages/automatic_scouts/automatic_scout_condition';
import AutoScoutSetting from './pages/automatic_scouts/auto_scout_setting';
import AutomaticScoutSetting from './pages/automatic_scouts/automatic_scout_setting';
import UseInfoReport from './pages/useinforeport';
import CompanyOfferReport from './pages/company_offer_report';
import MailMember from './pages/mail_member';

import './custom-select-box';

// Config Stimulus -- Alway require at bottom
import '../controllers';

const companyApplicant = new CompanyApplicant();
const companyScout = new CompanyScout();
const mailTemplate = new MailTemplate();
const mailTemplateSample = new MailTemplateSample();
const companyUser = new CompanyUser();
const dependentLocation = new DependentLocation();
const translationProfileIntro = new TranslationProfileIntro();
const scout = new Scout();
const recommendTileContainer = new RecommendTileContainer();
const jobTag = new JobTag();
const logoutDialog = new LogoutDialog();
const jobSearch = new JobSearch();
const ctAnnouncement = new CtAnnouncement();
const memberRecommendationSearch = new MemberRecommendationSearch();
const schedule = new Schedule();
const jobForm = new JobForm();
const flashMessage = new FlashMessage();
const resumeSearchResult = new ResumeSearchResult();
const autoScoutSetting = new AutoScoutSetting();
const automaticScoutSetting = new AutomaticScoutSetting();
automaticScoutSetting.ready();
const useinforeport = new UseInfoReport();
const companyOfferReport = new CompanyOfferReport();
const mailMember = new MailMember();

useinforeport.ready();
companyApplicant.togglePeriod();
dependentLocation.localSelect();
flashMessage.toastr_option();
resumeSearchResult.reloadPageByMemberSwitchesCookies();

AutoScoutMessageTemplate.ready();
window.AutoScoutMessageTemplate = AutoScoutMessageTemplate;
window.Interview = Interview;
ResumeSearches.ready();
window.ResumeSearches = ResumeSearches;
NewResumeSearches.ready();
window.NewResumeSearches = NewResumeSearches;
window.TranslationProfileIntro = translationProfileIntro;
window.Shared = Shared;
window.Cookie = Cookie;
window.CompanyApplicant = companyApplicant;
window.CompanyScout = companyScout;
window.MemberJobFolders = MemberJobFolders;
window.CandidateNotes = CandidateNotes;
window.Joblist = Joblist;
window.Cookies = require("js-cookie");
window.CompanyTools = require("./companytools");
window.CompanyProfile = require("./company_profile");
window.Location = require("./masters/location");
window.Currency = require("./masters/currency");
window.Job = require("./job");
window.RecommendTileContainer = recommendTileContainer;
window.JobTag = jobTag;
window.MemberRecommendationSearch = memberRecommendationSearch;
window.previewTabPanel = require("./preview_tab_panel");
window.MailTemplate = mailTemplate;
window.CompanyUser = companyUser;
window.Scout = scout;
window.JobSearch = jobSearch;
window.Schedule = schedule;
window.jobForm = jobForm;
window.CtAnnouncement = ctAnnouncement;
window.moment = moment;
window.toastr = require('toastr')
AutomaticScoutCondition.ready();
window.AutomaticScoutCondition = AutomaticScoutCondition;
window.AutoScoutSetting = autoScoutSetting;
window.AutomaticScoutSetting = automaticScoutSetting;
window.CompanyOfferReport = companyOfferReport;
window.MailMember = mailMember;

$(document).ready(() => {
  window.companyMessages = new TranslationSimple("#job_auto_replies");
  window.companyMessagesRegistration = new TranslationSimple(
    "#registration_auto_replies"
  );
  window.companyNotes = new CompanyNotes();
  window.companyProfileBasicInformation = new TranslationSimple(
    "#company-profile-basic-information"
  )
});
$(document).ready(() => {
  window.ResumeUpdateRequest = new ResumeUpdateRequest();
  window.companyMessages = new TranslationSimple('#job_auto_replies');
  window.companyMessagesRegistration = new TranslationSimple('#registration_auto_replies');
  window.companyNotes = new CompanyNotes;
  window.companyProfileBasicInformation = new TranslationSimple("#company-profile-basic-information");
  window.jobForm = new TranslationJob("#job-edit-form-scope");
  window.companyIntro = new TranslationProfileIntro(
    "#company-profile-intro-table"
  );
  Shared.reloadParentTab();
  Shared.initializeMatchLevels();
  window.previewTabPanel.selectFirstTab();
  window.CompanyWebEdit = new CompanyWebEdit();
  window.mailTemplateSample = new MailTemplateSample();
  window.message = new Message();
  translationProfileIntro.clickButton();
  companyUser.removeLink();
  logoutDialog.show();
  autoScoutSetting.ready();

  if (((!location.pathname.includes('candidatenotes') && !location.pathname.includes('automatic_scout_settings')) || (!document.referrer.includes('candidatenotes') && !document.referrer.includes('automatic_scout_settings') && document.referrer !== '')) && Cookies.get(`dj_candidate_note_${gon.current_company_user.id}`)) {
    Cookies.remove(`dj_candidate_note_${gon.current_company_user.id}`);
  }
});
